import React, { Component, createRef } from "react";
import { currencyFormatter } from "utils/currencyHelper";
import { withTranslation } from "react-i18next";
import "component/details/RoundDetails/styles.scss";
import { ReactComponent as CopyIcon } from "assets/icons/copy.svg";
import { copyToClipboard } from "utils/copyToClipboard";

class RoundDetails extends Component {
  constructor(props) {
    super(props);
    this.mainRef = createRef();
    this.iframeRef = createRef();
    this.inlineResultRef = createRef();
    this.viewResultButtonRef = createRef();
    this.onCopyClickHandler = this._onCopyClickHandler.bind(this);
    this.onToggleResultClick = this._onToggleResultClick.bind(this);
    this.state = {
      showToast: false,
      showInlineResult: false,
    };
  }

  _onCopyClickHandler() {
    copyToClipboard(this.props.details.id)
      .then(() => {
        this.setState({ showToast: true });
        setTimeout(() => this.setState({ showToast: false }), 3000);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  _onToggleResultClick() {
    this.setState((prevState) => ({
      showInlineResult: !prevState.showInlineResult,
    }));
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.showInlineResult &&
      !prevState.showInlineResult &&
      this.iframeRef.current
    ) {
      this.iframeRef.current.onload = () => {
        try {
          const iframeDoc =
            this.iframeRef.current.contentDocument ||
            this.iframeRef.current.contentWindow.document;
          if (iframeDoc && iframeDoc.body) {
            iframeDoc.body.style.overflow = "auto";
            iframeDoc.body.style.height = "100%";
            iframeDoc.body.style.width = "100%";
          }
        } catch (e) {
        }
      };

      if (this.inlineResultRef.current) {
        requestAnimationFrame(() => {
          try {
            this.inlineResultRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          } catch (err) {
            this.inlineResultRef.current.scrollIntoView();
          }
        });
      }
    }
    if (
      !this.state.showInlineResult &&
      prevState.showInlineResult &&
      this.viewResultButtonRef.current
    ) {
      requestAnimationFrame(() => {
        try {
          this.viewResultButtonRef.current.scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
        } catch (err) {
          this.viewResultButtonRef.current.scrollIntoView();
        }
      });
    }

    // If user navigates to a different round, collapse the inline result
    const prevId = prevProps.details ? prevProps.details.id : null;
    const currId = this.props.details ? this.props.details.id : null;
    if (prevId !== currId && this.state.showInlineResult) {
      this.setState({ showInlineResult: false });
    }
  }

  render() {
    let { details, t } = this.props;
    const gameResultUrl = details ? details.gameResultUrl : null;

    return (
      <div className="round-details" ref={this.mainRef}>
        <div className="title" data-testid="details-section-title">{t("details")}</div>
        <div className="row">
          <div className="col">
            <table>
              <tbody>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-status-label">
                      {t("status")}
                    </span>
                  </th>
                  <td>
                    {details && <span data-testid="detail-status-value">{details.status}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-round-id-label">
                      {t("roundId")}
                    </span>
                  </th>
                  <td>
                    {details && (
                      <div
                        className="copyIcon"
                        onClick={() => {
                          this.onCopyClickHandler();
                        }}
                      >
                        <span data-testid="detail-round-id-value">{details.id}</span>
                        <span data-testid="detail-round-id-copy-button">
                          <CopyIcon width="25" height="25" fill="#cccc" />
                        </span>
                      </div>
                    )}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-initiated-label">
                      {t("initiated")}
                    </span>
                  </th>
                  <td>
                    {details && <span data-testid="detail-initiated-value">{details.initiatedDate}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-completed-label">
                      {t("completed")}
                    </span>
                  </th>
                  <td>
                    {details && <span data-testid="detail-completed-value">{details.completedDate}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-type-label">
                      {t("type")}
                    </span>
                  </th>
                  <td>
                    {details && <span data-testid="detail-type-value">{details.type}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col">
            <table>
              <tbody>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-game-label">
                      {t("game")}
                    </span>
                  </th>
                  <td>
                    {details && <span data-testid="detail-game-value">{details.gameName}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-provider-label">
                      {t("provider")}
                    </span>
                  </th>
                  <td>
                    {details && <span data-testid="detail-provider-value">{details.provider}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-currency-label">
                      {t("currency")}
                    </span>
                  </th>
                  <td>
                    {details && <span data-testid="detail-currency-value">{details.currency}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-round-ref-id-label">
                      {t("roundRefId")}
                    </span>
                  </th>
                  <td>
                    {details && <span data-testid="detail-round-ref-id-value">{details.gameProviderRoundId}</span>}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col">
            <table>
              <tbody>
                {details && details.walletCurrency && (
                  <tr>
                    <th>
                      <span className={`${!details ? "dummy" : ""}`}>
                        {t("playerCurrency")}
                      </span>
                    </th>
                    <td>
                      <span>{details.walletCurrency}</span>
                    </td>
                  </tr>
                )}
                {details && details.walletConversionRate && (
                  <tr>
                    <th>
                      <span className={`${!details ? "dummy" : ""}`}>
                        {t("playerToGameFx")}
                      </span>
                    </th>
                    <td>
                      <span>{details.walletConversionRate}</span>
                    </td>
                  </tr>
                )}
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-start-balance-label">
                      {t("startBalance")}
                    </span>
                  </th>
                  <td>
                    {details && (
                      <span data-testid="detail-start-balance-value">{`${
                        details.startBalance
                          ? currencyFormatter(details.startBalance)
                          : currencyFormatter(0)
                      }`}</span>
                    )}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-end-balance-label">
                      {t("endBalance")}
                    </span>
                  </th>
                  <td>
                    {details && (
                      <span data-testid="detail-end-balance-value">{`${
                        details.endBalance
                          ? currencyFormatter(details.endBalance)
                          : currencyFormatter(0)
                      }`}</span>
                    )}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-total-bet-label">
                      {t("totalBet")}
                    </span>
                  </th>
                  <td>
                    {details && (
                      <span data-testid="detail-total-bet-value">{`${currencyFormatter(details.totalBet)}`}</span>
                    )}
                    {!details && <span className="dummy">loading</span>}
                  </td>
                </tr>
                {details && details.totalFreeBet && (
                  <tr>
                    <th>
                      <span className={`${!details ? "dummy" : ""}`}>
                        {t("totalFreeBet")}
                      </span>
                    </th>
                    <td>
                      <span>{`${currencyFormatter(
                        details.totalFreeBet,
                      )}`}</span>
                    </td>
                  </tr>
                )}
                <tr>
                  <th>
                    <span className={`${!details ? "dummy" : ""}`} data-testid="detail-total-payout-label">
                      {t("totalPayout")}
                    </span>
                  </th>
                  <td>
                    {!details && <span className="dummy">loading</span>}
                    {details && (
                      <span data-testid="detail-total-payout-value">{`${currencyFormatter(details.totalPayout)}`}</span>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {(gameResultUrl || this.props.onViewResultClick) && !this.state.showInlineResult && (
          <div className="row" ref={this.viewResultButtonRef}>
            <div className="col col-12 text-center">
              {!details && (
                <button className="btn btn-lg btn-secondary btn-rnd disabled">
                  <span className="dummy">{t("viewResults")}</span>
                </button>
              )}
              {details && (
                <button
                  className="btn btn-lg btn-secondary btn-rnd"
                  data-testid="view-result-button"
                  onClick={() => {
                    if (gameResultUrl) {
                      this.onToggleResultClick();
                    } else if (this.props.onViewResultClick) {
                      this.props.onViewResultClick();
                    }
                  }}
                >
                  {this.state.showInlineResult
                    ? t("hideResult")
                    : t("viewResult")}
                </button>
              )}
            </div>
          </div>
        )}
        {this.state.showInlineResult && gameResultUrl && (
          <div className="inline-result-container" ref={this.inlineResultRef}>
            <div className="title row">
              <div className="col">
                <span>{t("result")}</span>
              </div>
            </div>
            <div className="iframe-wrapper">
              <iframe
                ref={this.iframeRef}
                title="Game Round Result"
                src={gameResultUrl}
                className="result-iframe"
                scrolling="yes"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                allow="fullscreen"
              />
            </div>
            <div className="text-center hide-result-action">
              <button
                className="btn btn-lg btn-secondary btn-rnd"
                onClick={this.onToggleResultClick}
              >
                {t("hideResult")}
              </button>
            </div>
          </div>
        )}
        <div className="toast-holder d-flex justify-content-center align-items-center">
          <div className={`toast ${this.state.showToast ? "show active" : ""}`}>
            <div className="toast-body">
              <strong className="me-auto">{t("roundIdCopied")}</strong>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation("translation")(RoundDetails);
